import { useMutation, useQueryClient } from "@tanstack/react-query";

import { addCropExplorationTemplate } from "services";

import { ADD_CROP_EXPLORATION_TEMPLATES, GET_CROP_EXPLORATIONS, GET_CROP_EXPLORATION_TEMPLATES } from "consts";

export const useAddCropExplorationTemplate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [ADD_CROP_EXPLORATION_TEMPLATES],
    mutationFn: addCropExplorationTemplate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_CROP_EXPLORATIONS, GET_CROP_EXPLORATION_TEMPLATES] });
    },
  });
};
